import RequestOtpForm from '@/components/forms/RequestOtpForm';
import VerifyOtpForm from '@/components/forms/VerifyOtpForm';
import Modal from '@/components/modals/Modal';
import { otpModalI18n } from '@/i18n/shared/OtpModal.i18n';
import { signUpModalI18n } from '@/i18n/shared/SignUpModal.i18n';
import { useState } from 'react';

type Props = {
  onClose: () => void;
};

export default function SignUpModal({ onClose }: Props) {
  const [otpHasBeenSentTo, setOtpHasBeenSentTo] = useState<string | null>(null);

  return (
    <Modal
      onClose={onClose}
      closeOnOverlayClick={false}
      title={
        otpHasBeenSentTo ? otpModalI18n.title.en : signUpModalI18n.title.en
      }
    >
      {otpHasBeenSentTo === null ? (
        <div className="flex flex-col space-y-5">
          <p className="text-lg">{signUpModalI18n.description.en}</p>

          {/* <ul className="space-y-1">
            {signUpModalI18n.reasons.en.map((benefit) => (
              <li className="text-lg font-semibold" key={benefit}>
                {benefit}
              </li>
            ))}
          </ul> */}

          <RequestOtpForm
            submitButtonText={signUpModalI18n.cta.en}
            onSuccess={(email: string) => setOtpHasBeenSentTo(email)}
          />

          <div className="m-auto -mt-3 text-gray-700 dark:text-gray-300">
            {signUpModalI18n.promise.en}
          </div>
        </div>
      ) : (
        <div className="space-y-5">
          <p>{otpModalI18n.explanation.en}</p>

          <VerifyOtpForm email={otpHasBeenSentTo} />
        </div>
      )}
    </Modal>
  );
}
